"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersistentFormState = exports.PersistenceMode = void 0;
const mobx_1 = require("mobx");
const formstate_1 = require("formstate");
const in_memory_storage_1 = require("./in-memory-storage");
const form_helpers_1 = require("../form-helpers");
const domain_storage_1 = require("./domain-storage");
var PersistenceMode;
(function (PersistenceMode) {
    PersistenceMode[PersistenceMode["Session"] = 0] = "Session";
    PersistenceMode[PersistenceMode["Domain"] = 1] = "Domain";
    PersistenceMode[PersistenceMode["InMemory"] = 2] = "InMemory";
})(PersistenceMode = exports.PersistenceMode || (exports.PersistenceMode = {}));
class PersistentFormState extends formstate_1.FormState {
    constructor($, cacheKey, persistenceMode, autoSave, version) {
        super($);
        this.cacheKey = cacheKey;
        this.persistenceMode = persistenceMode;
        this.resetFormSuper = this.reset;
        this.save = () => {
            this.storageSystem.setItem(this.cacheKey, form_helpers_1.formStateToJS(this));
        };
        this.reset = () => {
            this.resetFormSuper();
            this.storageSystem.removeItem(this.cacheKey);
        };
        this.trackChange = () => {
            mobx_1.autorun(() => this.save(), { delay: 500 });
        };
        this.getCached = () => {
            const data = this.storageSystem.getItem(this.cacheKey);
            if (data) {
                form_helpers_1.setFormStateValues(this, data);
            }
        };
        if (PersistenceMode.Domain === this.persistenceMode) {
            if (!version) {
                throw 'Set a data structure version.';
            }
            this.storageSystem = new domain_storage_1.DomainStorage({ cacheKey, version });
        }
        else if (PersistenceMode.Session === this.persistenceMode) {
            throw 'Use of Session storage is currently unsafe';
        }
        else {
            this.storageSystem = in_memory_storage_1.MemoryStorage;
        }
        this.getCached();
        if (autoSave) {
            this.trackChange();
        }
    }
}
exports.PersistentFormState = PersistentFormState;
//# sourceMappingURL=persistent-form-state.js.map